/* =========================================================================
   3D scanning information — Laserman Technologies
   Vanilla JS, no dependencies, no build step. Scoped to #lm-scanning.

   Generated by tools/prepare_assets.py — edit the dev project's src/main.js.

   The same file backs the Shopify section and preview/index.html, so what you
   test in the preview is what runs live. The only branch is the enquiry form:
   Shopify's {% form 'contact' %} posts for real, while the preview marks its
   form with data-preview-form and this script shows the thank-you state.
   ========================================================================= */

(function () {
    'use strict';

    var root = document.getElementById('lm-scanning');
    if (!root) return;

    var entries = Array.prototype.slice.call(root.querySelectorAll('.entry'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('.group'));
    var search = root.querySelector('#kb-search');
    var counter = root.querySelector('#kb-result-count');
    var noResults = root.querySelector('#kb-no-results');

    /* Cache the searchable text once, so typing stays cheap. */
    entries.forEach(function (entry) {
        entry._kbText = (entry.textContent || '').toLowerCase().replace(/\s+/g, ' ');
    });

    /* ------------------------------------------------------------ Accordion */

    function setOpen(entry, open) {
        var btn = entry.querySelector('.entry-q');
        var body = entry.querySelector('.entry-body');
        if (!btn || !body) return;
        entry.classList.toggle('open', open);
        body.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
    }

    entries.forEach(function (entry) {
        var btn = entry.querySelector('.entry-q');
        if (!btn) return;
        setOpen(entry, entry.classList.contains('open'));
        btn.addEventListener('click', function () {
            setOpen(entry, !entry.classList.contains('open'));
        });
    });

    /* --------------------------------------------------------------- Search */
    /* The section chips are jump links, not filters — search is the only thing
       that hides anything. */

    function visibleEntries() {
        return entries.filter(function (e) { return !e.hidden; });
    }

    function apply() {
        var query = (search && search.value || '').trim().toLowerCase();
        var shown = 0;

        entries.forEach(function (entry) {
            var match = !query || entry._kbText.indexOf(query) !== -1;
            entry.hidden = !match;
            if (match) shown++;
        });

        /* Hide a group heading when nothing under it survived the search. */
        groups.forEach(function (group) {
            var any = Array.prototype.slice.call(group.querySelectorAll('.entry'))
                .some(function (e) { return !e.hidden; });
            group.hidden = !any;
        });

        if (noResults) noResults.hidden = shown !== 0;

        if (counter) {
            counter.textContent = query
                ? shown + ' of ' + entries.length + ' entries match “' + query + '”.'
                : entries.length + ' entries. Search, or jump to a section above.';
        }
    }

    if (search) {
        var timer;
        search.addEventListener('input', function () {
            clearTimeout(timer);
            timer = setTimeout(apply, 120);
        });
        /* Escape clears the search rather than the browser's own reset. */
        search.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') { search.value = ''; apply(); }
        });
    }

    /* ------------------------------------------------ Expand / collapse all */

    root.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-action]');
        if (!btn || !root.contains(btn)) return;
        var action = btn.dataset.action;

        if (action === 'expand') {
            visibleEntries().forEach(function (entry) { setOpen(entry, true); });
        } else if (action === 'collapse') {
            entries.forEach(function (entry) { setOpen(entry, false); });
        } else if (action === 'reset') {
            if (search) search.value = '';
            apply();
        }
    });

    /* ------------------------------------------- Jump links and deep links */

    /* Clear the theme's sticky header, if it has one. The height comes from
       --s3d-header-offset in the stylesheet so there is one number to change. */
    function scrollTo(el) {
        var declared = getComputedStyle(root).getPropertyValue('--s3d-header-offset');
        var offset = (parseFloat(declared) || 0) + 24;
        var top = window.pageYOffset + el.getBoundingClientRect().top - offset;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    function reveal(id) {
        if (!id) return;
        var target;
        try { target = root.querySelector('#' + CSS.escape(id)); } catch (err) { return; }
        if (!target) return;

        /* A search may be hiding the thing being linked to — clear it first. */
        if (target.hidden || (target.closest('.group') && target.closest('.group').hidden)) {
            if (search) search.value = '';
            apply();
        }

        if (target.classList && target.classList.contains('entry')) setOpen(target, true);

        scrollTo(target);
    }

    root.addEventListener('click', function (e) {
        var link = e.target.closest('a[href^="#"]');
        if (!link || !root.contains(link)) return;
        var id = link.getAttribute('href').slice(1);
        if (!id) return;
        var target;
        try { target = root.querySelector('#' + CSS.escape(id)); } catch (err) { return; }
        if (!target) return;
        e.preventDefault();
        if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', '#' + id);
        }
        reveal(id);
    });

    window.addEventListener('hashchange', function () {
        reveal(window.location.hash.replace('#', ''));
    });

    /* --------------------------------------------------- Missing image guard */
    /* Before `npm run images` has run (or if a source URL moves), don't show a
       broken-image icon — the figure's neutral background stands in. */

    root.querySelectorAll('.figure img, .entry-thumb img').forEach(function (img) {
        function fail() {
            img.style.visibility = 'hidden';
            var fig = img.closest('.figure') || img.closest('.entry-thumb');
            if (fig) fig.setAttribute('data-image-missing', '');
        }
        if (img.complete && img.naturalWidth === 0) fail();
        img.addEventListener('error', fail);
    });

    /* ---------------------------------------------------------------- Form */

    /* Live, this is Shopify's {% form 'contact' %} and the browser posts it.
       Only the preview's stand-in form is intercepted. */
    var previewForm = root.querySelector('[data-preview-form]');
    var previewSuccess = root.querySelector('[data-preview-success]');

    if (previewForm) {
        previewForm.addEventListener('submit', function (e) {
            e.preventDefault();
            if (!previewForm.reportValidity()) return;
            previewForm.hidden = true;
            if (previewSuccess) {
                previewSuccess.hidden = false;
                previewSuccess.setAttribute('tabindex', '-1');
                previewSuccess.focus();
            }
        });
    }

    /* ---------------------------------------------------------------- Start */

    apply();
    reveal(window.location.hash.replace('#', ''));
})();
